import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu, Typography, TableListActions } from 'seagull';
import { Trash } from 'seagull/icons';
import { useOnMount } from '~/hooks/useOnMount';
import { useLocaleKeys } from '~/i18n';
const DeleteServiceActionContent = (param)=>{
    let { service, draft, setDraft } = param;
    useOnMount(()=>{
        setDraft(draft.removeService(service.id));
    });
    const { t: cellTexts } = useLocaleKeys('pages.draftsDashboard.editTable.serviceCells');
    return /*#__PURE__*/ _jsx(Typography, {
        children: cellTexts.deleteServiceConfirmation({
            serviceName: service.name
        })
    });
};
export default function DeleteServiceAction(param) {
    let { service, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftsTexts } = useLocaleKeys('pages.draftsDashboard');
    const { t: cellTexts } = useLocaleKeys('pages.draftsDashboard.editTable.serviceCells');
    const onClick = ()=>{
        onOpenModal({
            skin: 'danger',
            submitOnNotDirty: true,
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    primaryButtonLabel: cellTexts.deleteServiceButton(),
                    title: cellTexts.deleteService(),
                    testId: "delete-service-modal-".concat(service.id),
                    content: /*#__PURE__*/ _jsx(DeleteServiceActionContent, {
                        service: service,
                        draft: draft,
                        setDraft: setDraft
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    };
    return /*#__PURE__*/ _jsx(TableListActions, {
        bi: {
            button: {
                name: 'draft_service_view'
            },
            menuTrigger: {
                name: 'draft_service_actions'
            }
        },
        testId: "table-list-actions-".concat(service.id),
        children: /*#__PURE__*/ _jsx(DropdownMenu.Item, {
            bi: {
                name: 'table_list_actions_delete'
            },
            skin: "error",
            iconStart: /*#__PURE__*/ _jsx(Trash, {}),
            onClick: onClick,
            testId: "table-list-actions-delete-".concat(service.id),
            disabled: isDisabled,
            tooltipProps: disabledTooltip != null ? {
                title: disabledTooltip,
                placement: 'right'
            } : undefined,
            children: draftsTexts.deleteService()
        })
    });
}
